import {Ticket} from './types';

interface DraftEvent {stage?: string; error?: string; ticket?: Ticket}

function parseEvent(frame: string): DraftEvent | null {
  const data = frame.split('\n').filter(line => line.startsWith('data:')).map(line => line.slice(5).trimStart()).join('\n');
  if (!data) return null;
  try { return JSON.parse(data) as DraftEvent; }
  catch { throw new Error('The draft response could not be read. Your message is saved.'); }
}

async function* readFrames(body: ReadableStream<Uint8Array>): AsyncGenerator<string> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    while (true) {
      const result = await reader.read();
      if (result.done) break;
      buffer += decoder.decode(result.value, {stream: true});
      buffer = buffer.replace(/\r\n/g, '\n');
      const frames = buffer.split('\n\n');
      buffer = frames.pop() ?? '';
      for (const frame of frames) yield frame;
    }
    buffer += decoder.decode();
    if (buffer.trim()) yield buffer;
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}

export async function consumeDraftStream(body: ReadableStream<Uint8Array>, progress: (stage: string) => void): Promise<Ticket> {
  let ticket: Ticket | undefined;
  for await (const frame of readFrames(body)) {
    const event = parseEvent(frame);
    if (!event) continue;
    if (event.error) throw new Error(event.error);
    if (event.stage) progress(event.stage);
    if (event.ticket) ticket = event.ticket;
  }
  if (!ticket) throw new Error('The connection was interrupted. Your message is saved.');
  return ticket;
}